import React, { useContext } from 'react';
import './EmailButton.css'
import { MailIconClicked, SMSButtonClicked } from '../../../../utils/Analytics.js';
import { getMobileOS, isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { AddToCartContext } from '../../add-to-cart/AddToCartContext';
import { getStoreId, singaporeStoreId } from '../../../../utils/StoreConfigManager';

const emailIcon = "https://cdn.obsess-vr.com/fendi/email-wishlist-final.png";

const EmailButton = ({ }) => {
    const { cartList, pricePrefix } = useContext(AddToCartContext);
    
    const paraOne = singaporeStoreId === getStoreId() ? `Here's your wishlist of favorite Fendi product from the Fendi Singapore Marina Bay Sands Boutique.%0A` : `Here's your wishlist of favorite Fendi product from the 57th Street Virtual Flagship.%0A`;
    const paraTWO = ' %0A %0AAt Fendi we respect your privacy. Your e-mail address was only used to send you this message and will not be kept for any promotional purposes. %0A %0A Best Regards %0A%0A Fendi';
    const wishListEmail = cartList.map(item => {
        return '%0AProduct Name: ' + item.TITLE + (item.PRICE > 0 ? ('%0AProduct Price: ' + pricePrefix + item.PRICE) : '') + '%0ADescription: ' + item.DESCRIPTION + '%0APDP URL: ' + item.PDP_URL;
    })

    const wishList = cartList.map(item => {
        return '%0AProduct Name: ' + item.TITLE + (item.PRICE > 0 ? ('%0AProduct Price: ' + pricePrefix + item.PRICE) : '') + '%0ADescription: ' + item.DESCRIPTION + '%0APDP URL: ' + item.PDP_URL;
    })

    const emailLink = "mailto:?subject=Fendi Wishlist&body=" + paraOne + wishListEmail.join('%0A') + paraTWO;

    const smsLink = getMobileOS() === 'iOS' ? 'sms:&body=' + wishList : 'sms:?body=' + wishList.join('%0A');

    return (
        <>
            <a onClick={() => MailIconClicked()} className={`call-to-order-btn-wrapper dark-bg margin15-auto hoverable'}`} style={{ margin: '8px auto' }} href={emailLink} target="_blank">
                <img src={emailIcon} /> 
                <span className="call-to-order-btn" >{`Email Wishlist`}</span>
            </a>
            {isMobileDevice() && <a onClick={() => SMSButtonClicked()} className={`call-to-order-btn-wrapper dark-bg margin15-auto hoverable'}`} style={{ margin: '8px auto' }} href={smsLink} target="_blank">
                <span className="call-to-order-btn" >{`SMS Wishlist`}</span>
            </a>}
        </>
    );
}

export default EmailButton;
